import { enClientPortalAssetDetailsCommon } from './Assets/AssetDetails'
import { enClientPortalAssetListPages } from './Assets/AssetList'

export const enClientPortalAssetsCommon = {
    assets: {
        ...enClientPortalAssetListPages,
        ...enClientPortalAssetDetailsCommon,
    },
}
